module.exports = __webpack_public_path__ + "img/75.cc192ffb.jpg";